export default "__VITE_ASSET__f09226ca__"